import React from 'react';
import Content, { ContentStatus, ContentType } from '../../models/Content';
import ContentManager from '../ContentManager';
import Typography from '../../components/Typography';
import EditablePage from '../../components/EditablePage';

const initFaq: Content = {
    type: ContentType.Faq,
    status: ContentStatus.Draft,
    title: '',
    description: '',
    data: '',
    isFeatured: false,
};

const CreateFaq: React.FC = () => {

    return (
        <EditablePage>
            <div className="faqs">
                <Typography variant="subtitle" textAlign="center">
                    CREATE FAQ
                </Typography>
                <ContentManager content={initFaq}>
                    <Typography variant="subtitle" color="primary" textAlign="center">
                        Please switch to editor mode to create FAQ
                    </Typography>
                </ContentManager>
            </div>
        </EditablePage>
    );
};

export default CreateFaq;
